module.exports = __webpack_public_path__ + "img/locked-mobile.e9762cbc.jpg";